import type { ProductListItem } from 'product-list/types/ProductsList'

import { AddProductCardAnimation } from '../components/AddProductCardAnimation/AddProductCardAnimation'
import { InspirationalClientProductCard } from '../components/productCards/InspirationalClientProductCard'
import { InspirationalServerProductCard } from '../components/productCards/InspirationalServerProductCard'
import { RenderingType } from '../types/InspirationalProductCard'
import type { ProductInfo } from '../types/product'

type RenderProductParams = {
	type: RenderingType
	moduleIndex: number
	productIndex: number
	product: ProductListItem
	isTwoColumnSize?: boolean
	shouldRenderSlideshowAnimation?: boolean
}

export const renderProduct = ({
	type,
	moduleIndex,
	productIndex,
	product,
	isTwoColumnSize,
	shouldRenderSlideshowAnimation,
}: RenderProductParams) => {
	const key = `module-${moduleIndex}-productCard-${productIndex}`
	const productCard =
		type === RenderingType.Client ? (
			<InspirationalClientProductCard
				key={key}
				product={product}
				isTwoColumnSize={isTwoColumnSize}
			/>
		) : (
			<InspirationalServerProductCard
				key={key}
				product={product}
				isTwoColumnSize={isTwoColumnSize}
			/>
		)

	return shouldRenderSlideshowAnimation ? (
		<AddProductCardAnimation>{productCard}</AddProductCardAnimation>
	) : (
		productCard
	)
}

type RenderProductsParams = {
	type: RenderingType
	moduleIndex: number
	products: ProductListItem[]
	shouldRenderSlideshowAnimation?: boolean
}

export const renderProducts = ({
	type,
	moduleIndex,
	products,
	shouldRenderSlideshowAnimation,
}: RenderProductsParams) => {
	return products.map((product, productIndex) =>
		renderProduct({
			type,
			product,
			moduleIndex,
			productIndex,
			shouldRenderSlideshowAnimation,
		})
	)
}

export const getProductInfoFromPreviousUrl = (
	previousUrl: string
): ProductInfo | null => {
	const [pathname, searchParamsString, ...otherParts] = previousUrl.split('?')

	if (!pathname || !searchParamsString || otherParts.length > 0) {
		return null
	}

	const searchParams = new URLSearchParams(searchParamsString)

	const id = pathname.split('/').at(-1)?.split('_').at(-1)
	const colorId = searchParams.get('c')

	if (!id || !colorId) {
		return null
	}
	return { id, colorId }
}
